import { useTranslations } from "next-intl";

import {
  type TLoginForgotPasswordProps,
  type TLoginInputProps,
  type TLoginSubmitProps,
} from "@/ui/components/sections/authentication/forms/Login/Login.config";
import {
  getLoginEmailProps,
  getLoginForgotPasswordProps,
  getLoginPasswordProps,
  getLoginSubmitProps,
  getLoginWithPasswordMessages,
} from "@/ui/components/sections/authentication/forms/Login/Login.utils";

export const useLoginWithPassword = (
  {
    email,
    password,
    forgotPassword,
    submit,
  }: {
    email: TLoginInputProps;
    password: TLoginInputProps;
    forgotPassword: TLoginForgotPasswordProps;
    submit: TLoginSubmitProps;
  },
) => {
  const t = useTranslations("Libs.UI.Components.LoginWithPassword");
  const messages = getLoginWithPasswordMessages(t);
  const resolvedSubmit = getLoginSubmitProps(submit, messages);

  return {
    emailProps: getLoginEmailProps(email, messages),
    forgotPassword: getLoginForgotPasswordProps(forgotPassword, messages),
    passwordProps: getLoginPasswordProps(password, messages),
    submitLabel: resolvedSubmit.label,
    submitProps: resolvedSubmit.props,
  };
};
